import { render, staticRenderFns } from "./filterItem.vue?vue&type=template&id=38d2b6ab&scoped=true&"
import script from "./filterItem.vue?vue&type=script&lang=js&"
export * from "./filterItem.vue?vue&type=script&lang=js&"
import style0 from "./filterItem.vue?vue&type=style&index=0&id=38d2b6ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2b6ab",
  null
  
)

export default component.exports